import { type ReactNode } from 'react';
import { Copy } from 'lucide-react';
import type { Approacher } from '../types';

const ROW = 'flex items-baseline justify-between gap-md py-sm';
const KEY =
  'shrink-0 text-[11px] uppercase tracking-wide text-text-tertiary/70';
const VAL = 'min-w-0 truncate text-right text-xs text-text-secondary';

function truncateWallet(addr: string): string {
  return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
}

function copyToClipboard(text: string): void {
  void globalThis.navigator.clipboard.writeText(text);
}

function Row({ label, value }: { label: string; value: string }): ReactNode {
  return (
    <div className={ROW}>
      <span className={KEY}>{label}</span>
      <span className={VAL}>{value}</span>
    </div>
  );
}

function WalletRow({ wallet }: { wallet: string }): ReactNode {
  return (
    <div className={ROW}>
      <span className={KEY}>Billetera USDC</span>
      <div className="flex items-center gap-xs">
        <span className="font-mono text-xs text-text-secondary">
          {truncateWallet(wallet)}
        </span>
        <button
          onClick={() => copyToClipboard(wallet)}
          className="text-text-tertiary transition-colors hover:text-text-primary"
          title="Copiar"
          aria-label="Copiar billetera"
        >
          <Copy size={12} />
        </button>
      </div>
    </div>
  );
}

function locationLine(a: Approacher): string {
  return [a.city, a.country].filter(Boolean).join(', ');
}

function Rows({ a }: { a: Approacher }): ReactNode {
  const loc = locationLine(a);
  return (
    <>
      {a.email && <Row label="Email" value={a.email} />}
      {a.phone && <Row label="Telefono" value={a.phone} />}
      {loc && <Row label="Ubicacion" value={loc} />}
      {a.birthdate && (
        <Row label="Cumpleanos" value={a.birthdate.slice(0, 10)} />
      )}
      {a.personal_ig_username && (
        <Row label="IG personal" value={`@${a.personal_ig_username}`} />
      )}
      {a.usdc_wallet && <WalletRow wallet={a.usdc_wallet} />}
      {a.manychat_subscriber_id && (
        <Row label="ManyChat ID" value={a.manychat_subscriber_id} />
      )}
    </>
  );
}

function hasAny(a: Approacher): boolean {
  return !!(
    a.email ||
    a.phone ||
    a.city ||
    a.country ||
    a.birthdate ||
    a.personal_ig_username ||
    a.usdc_wallet ||
    a.manychat_subscriber_id
  );
}

export function ApproacherFields({ a }: { a: Approacher }): ReactNode {
  if (!hasAny(a)) return null;
  return (
    <section className="space-y-xs">
      <h3 className="text-[10px] uppercase tracking-wider text-text-tertiary/60">
        Informacion
      </h3>
      <div className="divide-y divide-white/[0.04]">
        <Rows a={a} />
      </div>
    </section>
  );
}
